import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from "react-intl";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Paper } from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    root: {
        whiteSpace: "pre-line",
        padding: theme.spacing(4),
        margin: theme.spacing(2)
    }
}));
export const CarOrderDescription = (props) => {
    const classes = useStyles();
    return (_jsxs(Paper, { className: classes.root, children: [_jsx(Typography, { variant: "h4", paragraph: true, children: _jsx(FormattedMessage, { id: "dealer.pendingorders.description.header", description: "Car order information header", defaultMessage: "Information" }) }), _jsx(Typography, { children: _jsx(FormattedMessage, { id: "dealer.pendingorders.description.text", description: "car order information ", defaultMessage: `The car booking is returned to {name} after {return_days, plural, one {# days} other {# days}}.

					The car will be registered first on {legal_name}. Dealer confirms with stamp and signature the expected delivery date and confirmation that the car has been ordered.
					{legal_name} reserves the right to cancel the order if the requested date of delivery cannot be complied with.

					PS: Contact the customer for a review of all details in the car booking so that everything becomes as the customer wants. Any changes should be approved by {name}`, values: {
                        legal_name: (_jsx(FormattedMessage, { id: "tenant.legal_name", defaultMessage: "Kreditor AS", description: "The full legal name of the current tenant (financial institution)" })),
                        name: (_jsx(FormattedMessage, { id: "tenant.name", defaultMessage: "creditor", description: "The name of the current tenant (financial institution)" })),
                        return_days: 3
                    } }) })] }));
};
//# sourceMappingURL=CarOrderDescription.js.map